<template>
  <header>
    <b-navbar toggleable="lg" type="dark" variant="dark">
      <b-navbar-brand href="#">Admin</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <!-- <b-nav-form>
            <b-form-input size="sm" class="mr-sm-2" placeholder="Buscar..."></b-form-input>
            <b-button size="sm" class="my-2 my-sm-0" type="submit">Buscar</b-button>
          </b-nav-form>-->

          <b-nav-item-dropdown right>
            <!-- Using 'button-content' slot -->
            <template slot="button-content">
              <em>Opções</em>
            </template>
            <b-dropdown-item href="#">Perfil</b-dropdown-item>
            <b-dropdown-item-button @click="Logout"
              >Sair</b-dropdown-item-button
            >
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </header>
</template>
<script>
import authentication from "../util/authentication";
import router from "@/router";

export default {
  name: "Header",
  data() {
    return {};
  },
  mounted() {
    if (!authentication.isLoggedIn()) {
      router.push("/login");
    }
  },
  methods: {
    Logout() {
      authentication.logout();
    }
  }
};
</script>
<style scoped>
nav.navbar {
  background-color: #191919 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue